import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

import styles from './CountryDetailsPanel.module.scss';

import {
  CurrencyIcon,
  ExchangeIcon,
  TimeZoneIcon,
  LanguageIcon,
  ElectricityIcon,
  TransportationIcon,
  SafetyTipsIcon,
  DrivingRoadRulesIcon,
  PaymentIcon,
  TippingIcon,
  MobileNetworkIcon,
  CulturalNormsRulesIcon,
} from '../../../../../../components/Icons';
import { DestinationCountryDetails } from '../../../../../../types/trip.types';
import InfoSection from './InfoSection';

interface CountryDetailsPanelProps {
  countryData: DestinationCountryDetails;
  onClose: () => void;
}

const CountryDetailsPanel: FC<CountryDetailsPanelProps> = ({ countryData, onClose }) => {
  const { about_country } = countryData;

  if (!about_country) {
    return (
      <Box className={styles.countryDetailsPanel}>
        <Box className={styles.header}>
          <Typography
            variant="h6Bold"
            className={styles.title}
          >
            {countryData.name}
          </Typography>
          <Box
            className={styles.closeButton}
            onClick={onClose}
          >
            <Close />
          </Box>
        </Box>

        <Box className={styles.content}>
          <Box className={styles.sectionsContainer}>
            <Typography
              variant="h10"
              color="textSecondary"
              style={{ textAlign: 'center', padding: '20px' }}
            >
              Country information is currently unavailable.
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={styles.countryDetailsPanel}>
      <Box className={styles.header}>
        <Typography
          variant="h5Bold"
          className={styles.title}
        >
          {countryData.name}
        </Typography>
        <Box
          className={styles.closeButton}
          onClick={onClose}
        >
          <Close />
        </Box>
      </Box>

      <Box className={styles.content}>
        <Box className={styles.sectionsContainer}>
          {about_country.currency_info && (
            <InfoSection
              icon={<CurrencyIcon size={24} />}
              title="Currency"
              content={about_country.currency_info}
            />
          )}

          {about_country.exchenge_rate && (
            <InfoSection
              icon={<ExchangeIcon size={24} />}
              title="Average exchange rate"
              content={about_country.exchenge_rate}
            />
          )}

          {about_country.time_zone && (
            <InfoSection
              icon={<TimeZoneIcon size={24} />}
              title="Time Zone"
              content={about_country.time_zone}
            />
          )}

          {about_country.language && (
            <InfoSection
              icon={<LanguageIcon size={24} />}
              title="Language"
              content={about_country.language}
            />
          )}

          {about_country.electricity && (
            <InfoSection
              icon={<ElectricityIcon size={24} />}
              title="Electricity"
              content={about_country.electricity}
            />
          )}

          {about_country.transportation && (
            <InfoSection
              icon={<TransportationIcon size={24} />}
              title="Transportation"
              content={about_country.transportation}
            />
          )}

          {about_country.safety_tips && (
            <InfoSection
              icon={<SafetyTipsIcon size={24} />}
              title="Safety Tips"
              content={about_country.safety_tips}
            />
          )}

          {about_country.driving_rules && (
            <InfoSection
              icon={<DrivingRoadRulesIcon size={24} />}
              title="Driving & Road Rules"
              content={about_country.driving_rules}
            />
          )}

          {about_country.payment && (
            <InfoSection
              icon={<PaymentIcon size={24} />}
              title="Payment"
              content={about_country.payment}
            />
          )}

          {about_country.tipping && (
            <InfoSection
              icon={<TippingIcon size={24} />}
              title="Tipping"
              content={about_country.tipping}
            />
          )}

          {about_country.mobile_network && (
            <InfoSection
              icon={<MobileNetworkIcon size={24} />}
              title="Mobile Network"
              content={about_country.mobile_network}
            />
          )}

          {about_country.cultural_norms && (
            <InfoSection
              icon={<CulturalNormsRulesIcon size={24} />}
              title="Cultural Norms & Rules"
              content={about_country.cultural_norms}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CountryDetailsPanel;
